import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import axios from "axios";

export default function AttendancePieChart() {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [data, setData] = useState(null);

  const session = localStorage.getItem("currentSessionId");

  const formatDate = (isoStr) => {
    const date = new Date(isoStr);
    return date.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const fetchData = async () => {
    try {
      const todayISO = new Date().toISOString().split("T")[0];
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/attendance/stats?session=${session}&date=${todayISO}`
      );
      setData({ ...res.data, date: todayISO });
    } catch (err) {
      console.error(err);
      setData({ Present: 0, Absent: 0, Late: 0, onLeave: 0, date: new Date().toISOString().split("T")[0] });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!data || !chartRef.current) return;

    if (!chartInstance.current) {
      chartInstance.current = echarts.init(chartRef.current);
    }

    const chartData = Object.entries(data)
      .filter(([key]) => key !== "date")
      .map(([status, value]) => ({
        name: status === "onLeave" ? "Leave" : status,
        value,
      }));

    chartInstance.current.setOption({
      title: {
        text: `Students Attendance (${formatDate(data.date)})`,
        left: "center",
        textStyle: { fontSize: 14, fontWeight: "bold" },
      },
      tooltip: { trigger: "item" },
      series: [
        {
          name: "Attendance",
          type: "pie",
          radius: "45%",
          data: chartData,
          color: ["#93C5FD", "#3B82F6", "#FACC15", "#EF4444"],
          emphasis: {
            itemStyle: { shadowBlur: 10, shadowColor: "rgba(0,0,0,0.4)" },
          },
        },
      ],
    });
  }, [data]);

  return   <div
        ref={chartRef}
        style={{
          width: "100%",
          height: "250px",
          background: "#fff",
          borderRadius: "10px",
          padding: "10px",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
        }}
      />
}
